import { computed } from 'vue';
import { useAccount } from './useAccount';
import { useMapGetter } from './store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Presentation mode only: existing sector memberships and permissions still apply.
export function useSectorlessAccount() {
  const { accountId } = useAccount();
  const isFeatureEnabled = useMapGetter('accounts/isFeatureEnabledonAccount');
  const isSectorlessAccount = computed(() =>
    isFeatureEnabled.value(accountId.value, FEATURE_FLAGS.SECTORLESS_ACCOUNT)
  );
  return { isSectorlessAccount };
}
